import {registerMPElement} from 'common/util/register-element';
import {Component, ConfigOptions} from 'panel';

import {formatText} from '../../util/format-text';

import {BannerAttrs, BannerTheme, BannerSize} from './types';
import template from './index.jade';
import css from './index.styl?inline';

const iconFromTheme = new Map<BannerTheme, string>([
  [BannerTheme.Error, `warning`],
  [BannerTheme.Info, `info`],
  [BannerTheme.Success, `circle-checkmark`],
  [BannerTheme.Warn, `warning`],
]);

export default class Banner extends Component<{}, {}, unknown, BannerAttrs> {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      'body-text': `string`,
      'header-text': `string`,
      icon: {type: `string`, default: `from-theme`},
      theme: {type: `string`, enum: Object.values(BannerTheme), default: BannerTheme.Info},
      size: {type: `string`, enum: Object.values(BannerSize), default: BannerSize.Small},
      cta: `json`,
    };
  }

  get config(): ConfigOptions<{}, {}, BannerAttrs> {
    return {
      useShadowDom: true,
      css,
      template,
      defaultState: {},
      helpers: {
        formatText,
        getIcon: () =>
          this.attr(`icon`) === `from-theme` ? iconFromTheme.get(this.attr(`theme`) as BannerTheme) : this.attr(`icon`),
        handleCtaButtonClick: (actionName, value) => {
          const {trackEventName, autoDismiss, trackProps, href} = this.attr(`cta`);

          this.dispatchEvent(new CustomEvent(`action`, {detail: {value, actionName}}));

          if (trackEventName) {
            this.dispatchEvent(
              new CustomEvent(`track`, {
                bubbles: true,
                composed: true,
                cancelable: true,
                detail: {
                  eventName: trackEventName,
                  props: trackProps || {
                    'Action Name': actionName,
                    'Action Value': value,
                  },
                },
              }),
            );
          }

          // for self-dismissing banners (usually coming from django templates)
          if (autoDismiss) {
            this.style.display = `none`;
          }

          // if user wishes to make a link button
          if (href) {
            location.href = href;
          }
        },
      },
    };
  }
}

registerMPElement(`mp-banner`, Banner);
